module.exports = __webpack_public_path__ + "assets/img/3_1227_big.d2d500d0.jpg";